import './product-picks.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSProductPicks } from './product-picks';

components.register({
	selector: '.gs-ProductPicks',
	controller: GSProductPicks
});
